import { IOrganisationInfo } from "../../Common/organisationInfo";
import * as AccountModel from "../../Common/accountModel";

export interface IInitialSettings {
    organisationInfo: IOrganisationInfo;
    clientName?: string;
    onLoggedIn(data: AccountModel.IAccountModel);
    logOutUrl: string;
    loginUrl: string;
    recoverUrl: string;
    registerUrl: string;
    setExistingClientCredentialsUrl: string;
    appointmentsUrl: string;
    registerClientNumber?: number;
    clientHasEmailPassword: boolean;
    redirectUrl: string;
    registerClientNumberSameAsLoggedInClient: boolean;
    isLoginRequired: boolean;
    hideLoginButton: boolean;
    supplierId?: number;
}

export interface IStore {
    initialSettings: IInitialSettings;

    common: ICommon;

    forms: IForms;
}

export interface ICommon {
    clientName?: string;
    clientPublicId?: string;

    state: State;

    isBusy: boolean;

    errorMessage?: string;

    recoverPageState: TokenState;
    registerPageState: TokenState;
    setExistingClientCredentialsPageState: TokenState;
}

export interface IForms {
    loginForm: any;
    recoverForm: any;
    createForm: any;
    setExistingClientCredentialsForm: any;
}

export enum State {
    None,
    Login,
    Register,
    Recover,
    SetExistingClientCredentials,
}

export enum TokenState {
    Initial,
    ShowToken,
}
